import useInitPage from "../../../utils/initPage";
import Template from "../../../template/template";
import Header from "../header/header";
import DefRoutes from "../../../routes/routes.json";
import { Breadcrumb } from "../../../components/breadcrumb";

import "./styles.css";
import { useCallback, useState } from "react";
import { useRef } from "react";
import useApi from "../../../services/api";
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";

const faqTypes = {
  account: "Account",
  technical: "Technical",
  payments: "Payment",
  others: "Others",
};

const ITEMS_PER_PAGE = 10;

export const SearchResult = () => {
  useInitPage({ title: "" });
  const inputSearchRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const { state } = useLocation();
  const [pages, setPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [theme, setTheme] = useState("");
  const [questions, setQuestions] = useState([]);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [questionsByCategory, setQuestionsByCategory] = useState({
    account: [],
    technical: [],
    payments: [],
    others: [],
  });
  const [questionsToDisplay, setQuestionsToDisplay] = useState([]);

  useEffect(() => {
    const questionsOfAllPages = theme ? [...questionsByCategory[theme]] : [...filteredQuestions];

    const indexToStartSlice = ITEMS_PER_PAGE * (currentPage - 1);

    const questionsOfThisPage = questionsOfAllPages.splice(indexToStartSlice, ITEMS_PER_PAGE);

    console.log("setQuestionsToDisplay", questionsOfThisPage);
    setQuestionsToDisplay(questionsOfThisPage);
  }, [currentPage, filteredQuestions, questionsByCategory, theme]);

  useEffect(() => {
    const questionsOfAllPages = theme ? [...questionsByCategory[theme]] : [...filteredQuestions];

    const pagesCount = Math.ceil(questionsOfAllPages.length / ITEMS_PER_PAGE);

    console.log("setPages", pagesCount);
    setPages(pagesCount);
    console.log("setCurrentPage", 1);
    setCurrentPage(1);
  }, [filteredQuestions, questionsByCategory, theme]);

  const { ApiGetFaqArticles } = useApi();

  const filterQuestionsByCategory = useCallback((data) => {
    const account = data.filter((item) => item.type === faqTypes.account);
    const technical = data.filter((item) => item.type === faqTypes.technical);
    const payments = data.filter((item) => item.type === faqTypes.payments);
    const others = data.filter((item) => item.type === faqTypes.other);

    return { account, technical, payments, others };
  }, []);

  useEffect(() => {
    setQuestionsByCategory(filterQuestionsByCategory(filteredQuestions));
  }, [filterQuestionsByCategory, filteredQuestions]);

  const search = useCallback((list, value) => {
    const filtered = list.filter(
      (question) =>
        question.title.toLowerCase().includes(value.toLowerCase()) ||
        question.response.toLowerCase().includes(value.toLowerCase()),
    );

    setFilteredQuestions(filtered);
  }, []);

  const getAllQuestions = useCallback(async () => {
    const { data } = await ApiGetFaqArticles();

    const dataWithoutFaqs = data.filter((item) => item.type !== "");

    const dataModified = dataWithoutFaqs.map((item) => {
      item.response = item.response
        .replace(/<[^>]*>/g, " ")
        .replace("&nbsp;", "")
        .replace("&nbsp;", "");

      return item;
    });

    const pagesCount = Math.ceil(dataModified.length / ITEMS_PER_PAGE);

    setPages(pagesCount);
    setQuestions(dataModified);
    setLoading(false);

    setFilteredQuestions(dataModified);
    if (state) {
      search(dataModified, state);
    } else {
      setFilteredQuestions(dataModified);
    }
  }, [ApiGetFaqArticles, search, state]);

  useEffect(() => {
    getAllQuestions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = useCallback(() => {
    const searchValue = inputSearchRef.current.value;

    if (!searchValue) {
      setFilteredQuestions(questions);
      return;
    }

    search(questions, searchValue);
  }, [questions, search]);

  const handlePrevioustPage = useCallback(() => {
    if (currentPage === 1) return;

    setCurrentPage(currentPage - 1);
  }, [currentPage]);

  const handleNextPage = useCallback(() => {
    if (currentPage === pages) return;

    setCurrentPage(currentPage + 1);
  }, [currentPage, pages]);

  return (
    <Template>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="support-warp">
              <div className="support-warp-main">
                <Header />

                <div className="support-content">
                  <Breadcrumb data={[{ label: "Principal", link: DefRoutes.Support }, { label: "Busca" }]} />

                  <div className="support-search">
                    <h4>PESQUISAR NA CENTRAL DE SUPORTE</h4>
                    <div className="input-text icon-search" onClick={handleSearch}>
                      <form
                        onSubmit={(event) => {
                          event.preventDefault();
                          handleSearch();
                        }}
                      >
                        <input
                          defaultValue={state}
                          ref={inputSearchRef}
                          type="text"
                          onClick={(event) => event.stopPropagation()}
                        />
                      </form>
                    </div>
                  </div>

                  <div className="support-administrator">
                    <div className="administrator-header">
                      <div className="col-title">
                        <h1>{loading ? "CARREGANDO..." : "RESULTADOS DE BUSCA"}</h1>
                      </div>
                    </div>
                  </div>

                  {!loading && (
                    <section className="container-content">
                      <div className="all-categorys">
                        <div className="menu-category">
                          <ul>
                            <li>
                              <table>
                                <tr className={theme === "" ? "active" : ""} onClick={() => setTheme("")}>
                                  <td className="line-one menu-item-title">TODAS AS CATEGORIAS </td>
                                  <td className="line-two1 menu-item-count">{filteredQuestions.length}</td>
                                </tr>
                              </table>
                            </li>
                            <li>
                              <table>
                                <tr className={theme === "account" ? "active" : ""} onClick={() => setTheme("account")}>
                                  <td className="line-one menu-item-title">Contas</td>
                                  <td className="line-two menu-item-count">{questionsByCategory.account.length}</td>
                                </tr>
                              </table>
                            </li>
                            <li>
                              <table>
                                <tr
                                  className={theme === "technical" ? "active" : ""}
                                  onClick={() => setTheme("technical")}
                                >
                                  <td className="line-one menu-item-title">Informações tecnicas</td>
                                  <td className="line-two menu-item-count">{questionsByCategory.technical.length}</td>
                                </tr>
                              </table>
                            </li>
                            <li>
                              <table>
                                <tr
                                  className={theme === "payments" ? "active" : ""}
                                  onClick={() => setTheme("payments")}
                                >
                                  <td className="line-one menu-item-title">Pagamentos</td>
                                  <td className="line-two menu-item-count">{questionsByCategory.payments.length}</td>
                                </tr>
                              </table>
                            </li>
                            <li>
                              <table>
                                <tr className={theme === "others" ? "active" : ""} onClick={() => setTheme("others")}>
                                  <td className="line-one menu-item-title">Outros assuntos</td>
                                  <td className="line-two menu-item-count">{questionsByCategory.others.length}</td>
                                </tr>
                              </table>
                            </li>
                          </ul>
                        </div>

                        <div className="menu-category-mobile">
                          <ul>
                            <li>
                              ESCOLHA A CATEGORIA <span>+</span>
                              <ul>
                                <li>
                                  <table id="category-table">
                                    <tr onClick={() => setTheme("")}>
                                      <td className="line-one1">TODAS AS CATEGORIAS</td>
                                      <td className="line-two1">{filteredQuestions.length}</td>
                                    </tr>
                                  </table>
                                </li>
                                <li>
                                  <table>
                                    <tr onClick={() => setTheme("account")}>
                                      <td className="line-one">Contas</td>
                                      <td className="line-two">{questionsByCategory.account.length}</td>
                                    </tr>
                                  </table>
                                </li>
                                <li>
                                  <table>
                                    <tr onClick={() => setTheme("technical")}>
                                      <td className="line-one">Informações tecnicas</td>
                                      <td className="line-two">{questionsByCategory.technical.length}</td>
                                    </tr>
                                  </table>
                                </li>
                                <li>
                                  <table>
                                    <tr onClick={() => setTheme("payments")}>
                                      <td className="line-one">Pagamentos</td>
                                      <td className="line-two">{questionsByCategory.payments.length}</td>
                                    </tr>
                                  </table>
                                </li>
                                <li>
                                  <table>
                                    <tr onClick={() => setTheme("others")}>
                                      <td className="line-one">Outros assuntos</td>
                                      <td className="line-two">{questionsByCategory.others.length}</td>
                                    </tr>
                                  </table>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="all-returns">
                        <table id="returns-table">
                          {questionsToDisplay.map((question) => (
                            <tr key={question.id}>
                              <td className="row-txt">
                                <Link to={DefRoutes.ResponseFaq.replace(":id", question.id)}>
                                  <h5 className="cursor-pointer">{question.title}</h5>
                                </Link>
                                <p style={{ textOverflow: "ellipsis", height: "1.2em", overflow: "hidden" }}>
                                  {question.response}
                                </p>
                              </td>
                              <td>
                                <Link to={DefRoutes.ResponseFaq.replace(":id", question.id)}>
                                  <img src="/images/arrow-right.jpg" alt="" />
                                </Link>
                              </td>
                            </tr>
                          ))}
                        </table>

                        {pages && (
                          <div className="pagination">
                            <a href="#@" onClick={handlePrevioustPage}>
                              {"<"}
                            </a>

                            {Array.from(Array(pages).keys()).map((item, index) => {
                              const currentItem = item + 1;

                              return (
                                <a
                                  key={index}
                                  onClick={() => setCurrentPage(currentItem)}
                                  className={currentPage === currentItem ? "active" : ""}
                                  href="#@"
                                >
                                  {currentItem}
                                </a>
                              );
                            })}

                            <a href="#@" onClick={handleNextPage}>
                              {">"}
                            </a>
                          </div>
                        )}
                      </div>
                    </section>
                  )}

                  <div className="support-bot">
                    <div className="intro-box">
                      <h3>Não consegue encontrar o que está procurando?</h3>
                      <p>Conte para nós como podemos ajudar.</p>
                    </div>
                    <div className="intro-button-box">
                      <a href={DefRoutes.Request} className="btn btn-primary">
                        SOLICITAR SUPORTE{" "}
                        <span className="icon">
                          <img src="/images/support-w-ico.png" alt="" />
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Template>
  );
};
